const CloseBtnSvg = () => {
  return (
    <svg viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
      <line
        x1="5.39434"
        y1="5.7956"
        x2="15.8304"
        y2="16.2317"
        stroke="#9071AF"
        strokeWidth="1.16508"
      />
      <line
        x1="5.39375"
        y1="16.2316"
        x2="15.8299"
        y2="5.79553"
        stroke="#9071AF"
        strokeWidth="1.16508"
      />
    </svg>
  );
};

export default CloseBtnSvg;
